module.exports = __webpack_public_path__ + "media/images/mstile-310x150-46348e20a19a358ef14f0c70dc626a5b.png";